<template>
  <video controlslist="noremoteplayback" :id="playerId" class="video video-js" controls preload="auto"></video>
</template>
<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.css' // 引入 Video.js 的 CSS 文件。
export default {
  name:"vVideo",
  data() {
    return {
      player: null,
      playerId: `player_${Date.now().toString(36)}`,

    };
  },
  props:{
    options: {
      type: Object,
      default: () => ({
        autoplay: false,
        controls: true,
        sources: [{
          src: 'https://example.com/video.mp4',
          type: 'video/mp4'
        }]
      })
    }
  },
  mounted() {
    this.initPlayer()
  },
  beforeUnmount() {
    this.destroyPlayer()
  },
  methods: {
    initPlayer() {
      this.player = videojs(this.playerId, this.options, function() {
        console.log('Player ready')
      })
    },
    destroyPlayer() {
      if (this.player) {
        this.player.dispose()
      }
    }
  }
}
</script>
<style scoped>
.video{
  width: 400px;
  height: 200px;
}
</style>